export enum Transitions {
    slow = 'all 0.5s ease-in-out',
    medium = 'all 0.3s ease-in-out',
    fast = 'all 0.1s ease-in-out',
}
